import styled from "styled-components";
import { Minimize2 } from "lucide-react";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
`;

const ModalContent = styled.div`
  position: relative;
  width: 800px;
  height: 600px;
  animation: scaleIn 0.3s ease-out;
  display: flex;
  justify-content: center;
  align-items: center;

  @keyframes scaleIn {
    from {
      transform: scale(0.9);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    width: 90%;
    height: auto;
  }
`;

const ModalImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain; /* Always fit within the box */
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border: 3px solid #40e0d0;
  border-radius: 15px;
`;

const MinimizeButton = styled.div`
  position: absolute;
  top: -1rem;
  right: -1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  background: #34aebc;
  color: white;

  svg {
    color: white;
    width: 18px;
    height: 18px;
  }
`;

const ImageModal = ({ imageSrc, onClose }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent>
        <MinimizeButton onClick={onClose} aria-label="Minimize">
          <Minimize2 size={20} />
        </MinimizeButton>

        <ModalImage src={imageSrc} alt="Maximized view" />
      </ModalContent>
    </ModalOverlay>
  );
};

export default ImageModal;
